export const apiUrl = 'https://api.tacom.srv.br/';
export const praca = 'pnv';
export const apiLoginUrl = 'https://api.tacom.srv.br/authentication/v1/auth2/login';
export const username = 'citsoa-pnv@tacom.com.br';
export const password = '%66HHnn';

export const versaoSoftware = '4.4.16';
export const idioma = 'pt_BR'

export default {
}